module.exports = "/_next/static/images/2baaf78ad439b694acd6e80c0bc88357-slide-4-large.png";